import { Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useState } from 'react'
import Footer from '../../components/footer'
import Hero from '../../components/hero/Hero'
import Contact from '../../components/contact/Contact'
import { useModal } from '../../hooks/utils.hooks';
import PayStackForm from '../../components/donate/components/donationoverlay/PayStackFormModal';




/**
 * @function DonatePage
 * @description This component renders the donation page.
 * @returns {ReactElement} A React component that renders the donate page.
 * @example
 * <DonatePage />
/******  cf25fe56-4e70-480d-b979-c8c7df041234  *******/
export default function DonatePage() {

  const [title, setTitle] = useState(`Donation | Eraconneckt`);

  useEffect(() => {
    document.title = title;
    setTitle(title);
  }, [title]);


  const {
    closeModal: closePayStackModal,
  } = useModal();



  return (
    <>
      <Hero />
      <Container>
        <Row>
        <Col
          xs={{ span: 12 }}
          md={{ span: 8 }}
          style={{
            margin: "8rem auto"
          }}
        >
            <PayStackForm closeModal={closePayStackModal} />
          </Col>
        </Row>
      </Container>


      <Contact />
      <Footer />
    </>
  )
}
